import { timestampFromDate } from '@bufbuild/protobuf/wkt';
import { Client } from '@connectrpc/connect';

import { WebauthnService } from './espb/webauthn_service_pb';
import { requireFieldNotEmpty } from './grpcUtils';
import { toSyncDto } from './sync';
import { SyncUpdate, CredentialType, Email, WebauthnPrfSupportStatus } from './types';

export default class WebauthnServiceClient {
  constructor(private readonly espbClient: Client<typeof WebauthnService>) {}

  async unlockSessionInit(): Promise<{
    optionsJson: string;
    requestId: string;
  }> {
    const resp = await this.espbClient.unlockSessionInit({});
    return {
      optionsJson: requireFieldNotEmpty(resp.optionsJson),
      requestId: requireFieldNotEmpty(resp.requestId),
    };
  }

  async unlockSessionFinish(
    requestId: string,
    responseJson: string,
    maxExpiresAt: Date,
  ): Promise<SyncUpdate> {
    const resp = await this.espbClient.unlockSessionFinish({
      requestId,
      responseJson,
      maxExpiresAt: timestampFromDate(maxExpiresAt),
    });
    return toSyncDto(requireFieldNotEmpty(resp.syncUpdate));
  }

  async registerCredentialInit(credentialType: CredentialType): Promise<{
    optionsJson: string;
    requestId: string;
  }> {
    const resp = await this.espbClient.registerCredentialInit({ credentialType });
    return {
      optionsJson: requireFieldNotEmpty(resp.optionsJson),
      requestId: requireFieldNotEmpty(resp.requestId),
    };
  }

  async RegisterCredentialForAccountCreationInit(email: Email): Promise<{
    optionsJson: string;
    requestId: string;
  }> {
    const resp = await this.espbClient.registerCredentialForAccountCreationInit({ email });
    return {
      optionsJson: requireFieldNotEmpty(resp.optionsJson),
      requestId: requireFieldNotEmpty(resp.requestId),
    };
  }

  async registerCredentialFinish(
    requestId: string,
    responseJson: string,
    prfSupportStatus: WebauthnPrfSupportStatus,
  ): Promise<SyncUpdate> {
    const resp = await this.espbClient.registerCredentialFinish({
      requestId,
      responseJson,
      prfSupportStatus,
    });
    return toSyncDto(requireFieldNotEmpty(resp.syncUpdate));
  }

  async deleteCredentials(webauthnIds: string[]): Promise<SyncUpdate> {
    const resp = await this.espbClient.deleteCredentials({ webauthnIds });
    return toSyncDto(requireFieldNotEmpty(resp.syncUpdate));
  }
}
